import * as s from './ProgressBar.css';

interface ProgressBarProps {
  /** Progress value 0-100 */
  value: number;
  variant?: 'full' | 'mini';
  /** Accessible label (used in full variant) */
  label?: string;
  className?: string;
}

export function ProgressBar({ value, variant = 'full', label, className }: ProgressBarProps) {
  const clampedValue = Math.min(100, Math.max(0, value));

  if (variant === 'mini') {
    return (
      <div
        className={`${s.track({ variant: 'mini' })}${className ? ` ${className}` : ''}`}
        role="progressbar"
        aria-valuenow={clampedValue}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label ?? `진행도 ${clampedValue}%`}
      >
        <div className={s.fill({ variant: 'mini' })} style={{ width: `${clampedValue}%` }} />
      </div>
    );
  }

  return (
    <div
      className={`${s.track({ variant: 'full' })}${className ? ` ${className}` : ''}`}
      role="progressbar"
      aria-valuenow={clampedValue}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label ?? `진행도 ${clampedValue}%`}
    >
      <div className={s.fill({ variant: 'full' })} style={{ width: `${clampedValue}%` }} />
    </div>
  );
}
